import React from 'react';
import { Link } from 'react-router-dom';
import AccountTileIcon from '../ui/AccountTileIcon';

export function profileInitial(name, email) {
  const src = (name || email || '?').trim();
  return src.charAt(0).toUpperCase();
}

export function OverviewStat({ label, value, hint, ...rest }) {
  return (
    <div className="customer-account__stat" {...rest}>
      <span className="customer-account__stat-value">{value}</span>
      <span className="customer-account__stat-label">{label}</span>
      {hint ? <span className="customer-account__stat-hint">{hint}</span> : null}
    </div>
  );
}

export function QuickAction({ to, href, icon, title, desc, external, className = '' }) {
  const actionClass = `customer-account__action${className ? ` ${className}` : ''}`;
  const inner = (
    <>
      <span className="customer-account__action-icon" aria-hidden="true">
        <AccountTileIcon name={icon} />
      </span>
      <span className="customer-account__action-text">
        <span className="customer-account__action-title">{title}</span>
        <span className="customer-account__action-desc">{desc}</span>
      </span>
    </>
  );
  if (href) {
    return (
      <a
        href={href}
        className={actionClass}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
      >
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={actionClass}>
      {inner}
    </Link>
  );
}

export function AccountHubWelcome({
  eyebrow,
  name,
  email,
  roleBadge,
  primaryAction,
  onLogout,
}) {
  const emailShown = (email || '').trim();
  return (
    <header className="customer-account__welcome">
      <div className="customer-account__identity">
        <span className="customer-account__avatar" aria-hidden="true">
          {profileInitial(name, emailShown)}
        </span>
        <div className="customer-account__who">
          <p className="customer-account__eyebrow">{eyebrow}</p>
          <h1 className="customer-account__name">{name}</h1>
          {emailShown ? <p className="customer-account__email">{emailShown}</p> : null}
          {roleBadge ? <span className="customer-account__role-badge">{roleBadge}</span> : null}
        </div>
      </div>
      <div className="customer-account__header-actions">
        {primaryAction}
        <button type="button" className="btn btn-outline-secondary btn-sm rounded-pill px-3" onClick={onLogout}>
          Sign out
        </button>
      </div>
    </header>
  );
}

export function AccountHubNav({ tabs, tab, onTab }) {
  return (
    <nav className="customer-account__nav" aria-label="Account sections">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`customer-account__nav-btn${tab === t.id ? ' is-active' : ''}`}
          onClick={() => onTab(t.id)}
          aria-current={tab === t.id ? 'page' : undefined}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
